import { useMutation, useQueryClient } from 'react-query'

import { getFeeDistributorContract } from '~/contracts/getFeeDistributorContract'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'
import { useVESISParams } from '../../../hooks/useVESISParams'

export function useClaimLock() {
	const { config } = useVESISParams()

	const { web3, account } = useWallet()

	const queryClient = useQueryClient()

	return useMutation(
		async () => {
			const contract = getFeeDistributorContract(config, web3).connect(
				web3.getSigner(account)
			)

			const tx = await contract.claim()

			await tx.wait()
		},
		{
			onSuccess() {
				queryClient.invalidateQueries(
					sisTokenKeys.balance(config.chain.id, account)
				)
				queryClient.invalidateQueries(['sis-lock'])
			},
		}
	)
}
